import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  debitCard__label: () => i18n.t(i18nKeys.fastPay__debitCard__label),
  expDate__label: () => i18n.t(i18nKeys.fastPay__expDate__label),
  cvcNumber__label: () => i18n.t(i18nKeys.fastPay__cvcNumber__label),
  addDebitCard__primaryAction: () => i18n.t(i18nKeys.fastPay__addDebitCard__primaryAction),
  addDebitCard__secondaryAction: () => i18n.t(i18nKeys.fastPay__addDebitCard__secondaryAction),
  cvcModal__primaryAction: () => i18n.t(i18nKeys.fastPay__cvcModal__primaryAction),
  cvcModal__title: () => i18n.t(i18nKeys.fastPay__cvcModal__title),
  cvcIcon__accessibilityLabel: () => i18n.t(i18nKeys.fastPay__cvcIcon__accessibilityLabel)
}